/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */

'use-strict';

import { IScope } from 'angular';
import { EFileSection } from '../../../src/app/@shared-types/misc/file';
import { FileInput } from '../../../src/app/@types';
import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { ConfigService } from '../../../shared/config/config.service';
import { NumberConversionService } from '../../../shared/converter/number-converter.service';
import { FileService } from '../../../shared/storage/file.service';
import { DeepPartial } from '../../../src/app/@shared-types';
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';

interface RegistrationScope extends IScope {
  sending: boolean,
  exitForm: () => void,
  exit: (data: VehicleFormComponentExitFunction) => void,
  formTransmission: () => void,
  vehicle: AutoboardVehicle,
  newVehicleData: {
    files: FileInput[],
    state: string,
    license: string,
    registration?: string | null,
    deregistration?: string | null,
  },
  form: {
    type: 'registration' | 'deregistration',
  }
  vehicleStates: { [key: string]: string },
}

/* @ngInject */
export default function RegistrationFormController(
  $scope: RegistrationScope,
  fileService: FileService,
  salesApiService: SalesAPIService,
  numberConversionService: NumberConversionService,
  configService: ConfigService,
): void {
  $scope.sending = false;
  $scope.vehicleStates = configService.get('sales_car_types') || {};

  $scope.form = {
    type: 'registration',
  };
  $scope.newVehicleData = {
    files: [],
    license: $scope.vehicle.vehicleData.registration?.licence || '',
    registration: $scope.vehicle.vehicleData.registration?.firstRegistration ? undefined : null,
    deregistration: null,
    state: $scope.vehicle.vehicleData.availability.state!,
  };

  $scope.exitForm = () => $scope.exit({ removeLock: true });

  $scope.formTransmission = async () => {
    $scope.sending = true;

    for (const file of $scope.newVehicleData.files) {
      if (file.file !== null) {
        await fileService.uploadContextualFile(
          file.file,
          file.progressBar,
          {
            identifier: String($scope.vehicle._id),
            section: EFileSection.VEHICLE,
            type: file.fileType,
          },
        );
      }
    }

    const changedVals: DeepPartial<AutoboardVehicle> = {
      _id: $scope.vehicle._id,
      vehicleData: {
        availability: {
          state: $scope.newVehicleData.state,
          stateDescription: $scope.vehicleStates[$scope.newVehicleData.state],
        },
      },
    };

    if ($scope.form.type === 'registration') {
      changedVals.vehicleData!.registration = {
        licence: $scope.newVehicleData.license,
        registered: true,
      };

      if (!$scope.vehicle.vehicleData.registration?.firstRegistration && $scope.newVehicleData.registration) {
        changedVals.vehicleData!.registration.firstRegistration = numberConversionService.frontendStringToDate($scope.newVehicleData.registration);
      }
    } else if ($scope.newVehicleData.deregistration) {
      changedVals.vehicleData!.registration = {
        licence: '',
        registered: false,
        deregistrationDate: numberConversionService.frontendStringToDate($scope.newVehicleData.deregistration),
      };
    }

    await salesApiService.putVehicle(changedVals);
    return $scope.exit({});
  };
}
